export function flutterColorToHex(colorint) {
  // Extract ARGB components
  const alpha = (colorint >> 24) & 0xff;
  const red = (colorint >> 16) & 0xff;
  const green = (colorint >> 8) & 0xff;
  const blue = colorint & 0xff;

  const res = `#${[red, green, blue]
    .map((c) => c.toString(16).padStart(2, "0"))
    .join("")}`;
  if (res === "#000000") {
    return "transparent";
  }
  // Convert each component to a 2-digit hex value and combine them
  return res;
}

export function HexColorToFlutter(hex) {
  // Remove the leading '#' if it exists
  hex = hex.replace("#", "");

  // If the hex is in RGB format (6 characters), prepend 'FF' for full opacity
  if (hex.length === 6) {
    hex = "FF" + hex;
  }

  // Parse the hex string as an integer
  return parseInt(hex, 16);
}
